<app-data-grid-comp
    category="ImportLog"
    [gridId]="gridId"
    hideActionButtons="true"
    [columns]="columns"
    [filterCategories]="filterCategories"
    [gridDataResult]="gridDataResult"
    [pageSize]="pageSize"
    [skip]="skip"
    [rowSelectionSettings]="{
        canSelectRows: false,
        selectableMode: 'multiple',
        selectRowBy: 'id'
    }"
    clickableRows="false"
    [isLoading]="isLoading"
    [sortable]="{
        mode: 'multiple'
    }"
    [sortableColumns]="sortableColumns"
    export="customExcel"
    (emitExportEvent)="allData()"
    (emitGridStateChangeEvent)="gridStateChange($event)"
></app-data-grid-comp>

<kendo-excelexport
    [data]="excelData"
    [fileName]="fileName"
    #excelexport
>
    <kendo-excelexport-column
        *ngFor="let column of excelColumns"
        [field]="column.field"
        [title]="column.title"
    >
    </kendo-excelexport-column>
</kendo-excelexport>